import { render, staticRenderFns } from "./InventoryBlind.vue?vue&type=template&id=208be2ea&"
import script from "./InventoryBlind.vue?vue&type=script&lang=js&"
export * from "./InventoryBlind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports